define('module/map',[
    'jquery',
    'underscore',
    'cnf'
], function($,_,Cnf){
    'use strict';
    
    return function()
    {
        this.options={
            triggerSelector:'.trigger-google-map',
            iconRatio:309/547,
            iconHeight:60
        };
        
        this.init=function()
        {
            this.initOption();
            this.initMap();
        };
        
        this.initOption=function()
        {
            this.$map=Cnf.$app.find(this.options.triggerSelector);
            this.iMap=this.$map.length;
        };
        
        this.initMap=function()
        {
            if(this.iMap<=0) {
                return;
            }
            
            for(var i=0;i<this.iMap;i++) {
                this.requirements().done(_.bind(this.addMap, this, this.$map.eq(i).find('.map')[0], {
                    lat:this.$map.eq(i).data('lat'),
                    lng:this.$map.eq(i).data('lng')
                }));
            }
        };
        
        this.requirements=function()
        {
            var def=new $.Deferred();
            
            if(
                    (typeof google==='undefined')
                    || (typeof google.maps==='undefined')
            ) {
                $.getScript('https://maps.google.com/maps/api/js?key='+window.cnf.gmKey + '&language=' + (window.cnf.current.langRegion || 'de-DE'), function()
                {
                    def.resolve();
                });
            } else {
                def.resolve();
            }
            
            return def.promise();
        };
        
        this.addMap=function(el,data)
        {
            var oMap=new google.maps.Map(el, {
                center: {
                    lat: data.lat,
                    lng: data.lng
                },
                zoom: 15
            });
            
            var marker=new google.maps.Marker({
                position: new google.maps.LatLng(data.lat, data.lng),
                icon:{
                    url:  '/content/themes/cortex/assets/images/icon/map-picker.png',
                    scaledSize: new google.maps.Size((this.options.iconHeight *this.options.iconRatio), this.options.iconHeight)
                },
                map:oMap
            });
        };
        
        this.init();
    };
});
